var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { focusTrapHandler } from "@ts/helpers/focus";
export var initMainNav = function () {
    // Media Query for Mobile
    var mediaQuery = window.matchMedia("(max-width: 960px)");
    // Focus Trap Variables
    var focusTrap;
    var currentMobileNav;
    // DOM Elements
    var html = document.querySelector('html');
    var header = document.querySelector('.js-header');
    var navWrapper = header.querySelector('.js-main-nav-wrapper');
    var mobileNav = header.querySelector('.js-mobile-nav');
    var mobileMenuButton = header.querySelector('.js-mobile-nav-menu');
    var mobileMenuButtons = mobileNav.querySelectorAll('button');
    var mobileSearchButtons = header.querySelectorAll('.js-mobile-nav-search');
    var mobileCloseButtons = document.querySelectorAll('.js-mobile-nav-close');
    var mobileSearchPanel = document.querySelector('.js-mobile-search');
    var desktopNav = document.querySelector('.js-desktop-nav');
    var desktopNavOverlay = document.querySelector('.js-desktop-nav-overlay');
    var mainNavButtons = desktopNav.querySelectorAll(".js-desktop-nav_l1-button");
    var mainNavPanels = desktopNav.querySelectorAll('.js-desktop-nav_l1-panel');
    // Utility Functions
    var addFocusTrap = function (element) {
        focusTrap = focusTrapHandler({
            element: element,
            additionalElements: __spreadArray([mobileMenuButton], Array.from(mobileSearchButtons), true),
        });
        element.addEventListener('keydown', focusTrap);
    };
    var removeFocusTrap = function (element) {
        if (element) {
            element.removeEventListener('keydown', focusTrap);
        }
    };
    var closeMobileNav = function () {
        mobileMenuButtons.forEach(function (button) {
            button.setAttribute('aria-expanded', "false");
        });
        navWrapper.classList.remove('c-main-nav--active');
        mobileSearchPanel.classList.remove('c-main-nav--active');
        html.classList.remove('u-overflow-hidden');
        removeFocusTrap(currentMobileNav);
    };
    var closeDesktopNav = function () {
        desktopNav.classList.remove('c-main-nav--open');
        mainNavButtons.forEach(function (button) {
            button.setAttribute("aria-expanded", "false");
        });
        mainNavPanels.forEach(function (panel) {
            var _a;
            panel.classList.remove('c-main-nav_l1-panel--active');
            var icon = (_a = panel.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.js-desktop-nav_l1-link-icon');
            icon === null || icon === void 0 ? void 0 : icon.classList.remove('c-main-nav_l1-link-icon--active');
        });
    };
    // Mobile Navigation Handlers
    mobileMenuButton.addEventListener('click', function () {
        navWrapper.classList.add('c-main-nav--active');
        html.classList.add('u-overflow-hidden');
        addFocusTrap(navWrapper);
        currentMobileNav = navWrapper;
    });
    mobileCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            closeMobileNav();
            mobileMenuButton.focus();
        });
    });
    mobileSearchButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            mobileSearchPanel.classList.add('c-main-nav--active');
            html.classList.add('u-overflow-hidden');
            addFocusTrap(mobileSearchPanel);
            currentMobileNav = mobileSearchPanel;
        });
    });
    var setupMobileNavigation = function (nav, level) {
        if (level === void 0) { level = 0; }
        var list = nav.querySelector(':scope > .js-nav-list');
        var buttons = list.querySelectorAll(':scope > li > .js-button');
        buttons.forEach(function (button) {
            var _a;
            var subNav = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(':scope > .js-sub-nav');
            var backButton = subNav.querySelector(':scope > .js-back-button');
            button.addEventListener('click', function () {
                var handleTransitionEnd = function () {
                    nav.classList.add('u-invisible');
                    removeFocusTrap(currentMobileNav);
                    addFocusTrap(subNav);
                    currentMobileNav = subNav;
                    nav.removeEventListener('transitionend', handleTransitionEnd);
                };
                button.setAttribute('aria-expanded', 'true');
                nav.addEventListener('transitionend', handleTransitionEnd);
                if (mediaQuery.matches) {
                    var panelClass = level === 0 ? 'c-main-nav_panel--inactive' : 'c-main-nav_sub-panel--inactive';
                    nav.classList.add(panelClass);
                    nav.classList.remove('u-overflow-scroll');
                    subNav.classList.add('c-main-nav_sub-panel--active');
                    subNav.classList.add('u-overflow-scroll');
                    subNav.classList.remove('u-invisible');
                }
            });
            backButton.addEventListener('click', function () {
                var handleTransitionEnd = function () {
                    subNav.classList.add('u-invisible');
                    removeFocusTrap(currentMobileNav);
                    addFocusTrap(nav);
                    currentMobileNav = nav;
                    nav.removeEventListener('transitionend', handleTransitionEnd);
                };
                button.setAttribute('aria-expanded', 'false');
                nav.addEventListener('transitionend', handleTransitionEnd);
                if (mediaQuery.matches) {
                    var panelClass = level === 0 ? 'c-main-nav_panel--inactive' : 'c-main-nav_sub-panel--inactive';
                    nav.classList.remove(panelClass);
                    nav.classList.remove('u-invisible');
                    nav.classList.add('u-overflow-scroll');
                    subNav.classList.remove('c-main-nav_sub-panel--active');
                    subNav.classList.remove('u-overflow-scroll');
                }
            });
            setupMobileNavigation(subNav, level + 1);
        });
    };
    // Desktop Navigation Handlers
    mainNavButtons.forEach(function (button) {
        button.addEventListener('click', function (evt) {
            var _a;
            var panel = (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.js-desktop-nav_l1-panel');
            var icon = button.querySelector('.js-desktop-nav_l1-link-icon');
            var isActive = panel.classList.contains('c-main-nav_l1-panel--active');
            closeDesktopNav();
            panel.addEventListener('focusout', function (event) {
                var relatedTarget = event.relatedTarget;
                if (relatedTarget && !relatedTarget.closest('.js-desktop-nav_l1-panel')) {
                    desktopNav.classList.remove('c-main-nav--open');
                    icon === null || icon === void 0 ? void 0 : icon.classList.remove('c-main-nav_l1-link-icon--active');
                    panel.classList.remove("c-main-nav_l1-panel--active");
                    button.setAttribute("aria-expanded", "false");
                }
            });
            if (!mediaQuery.matches) {
                if (isActive) {
                    desktopNav.classList.remove('c-main-nav--open');
                    icon === null || icon === void 0 ? void 0 : icon.classList.remove('c-main-nav_l1-link-icon--active');
                    panel.classList.remove("c-main-nav_l1-panel--active");
                    button.setAttribute("aria-expanded", "false");
                }
                else {
                    desktopNav.classList.add('c-main-nav--open');
                    icon === null || icon === void 0 ? void 0 : icon.classList.add('c-main-nav_l1-link-icon--active');
                    panel.classList.add("c-main-nav_l1-panel--active");
                    button.setAttribute("aria-expanded", "true");
                }
            }
        });
    });
    // Close all navigation on click outside
    document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target.closest('.js-desktop-nav')) {
            closeDesktopNav();
        }
    });
    // Close all navigation on click overlay
    desktopNavOverlay.addEventListener('click', function (event) {
        closeDesktopNav();
    });
    // Handle Window Resize
    window.addEventListener('resize', function () {
        if (mediaQuery.matches) {
            closeDesktopNav();
        }
        else {
            closeMobileNav();
        }
    });
    // Initialize Mobile Navigation
    setupMobileNavigation(mobileNav);
};
